import React, { useState } from 'react';
import { Box, Tab, Tabs, Typography, Skeleton } from '@mui/material';
import { ReactFitty } from 'react-fitty';
import FluidBarcode from './FluidBarcode';
import FluidQrcode from './FluidQrcode';

const TYPES = ['promoCode', 'barcode', 'qrCode'];
const LABELS = { promoCode: 'Promo code', barcode: 'Barcode', qrCode: 'QR code' };

export default function RedemptionCodeDisplay({ codes = {}, enabledTypes, activeType, onTypeChange, showEmptyFields = false }) {
  const available = enabledTypes || TYPES.filter((type) => Boolean(codes[type]));
  const [selected, setSelected] = useState(null);
  const requested = activeType ?? selected;
  const active = available.includes(requested) ? requested : available[0];
  if (!available.length) return showEmptyFields ? <Skeleton aria-label="Redemption code" height={80} /> : null;
  return (
    <Box sx={{ my: 1, minWidth: 0, width: '100%' }}>
      <Tabs value={active} variant="fullWidth" aria-label="Redemption codes"
        onChange={(_, value) => { setSelected(value); onTypeChange?.(value); }}>
        {available.map((type) => <Tab key={type} value={type} label={LABELS[type]} />)}
      </Tabs>
      <Box role="tabpanel" aria-label={`${LABELS[active]} preview`} sx={{ minWidth: 0 }}>
        {active === 'promoCode' && (
          <Box sx={{ border: '1px solid #ddd', borderRadius: '4px', p: 4, mb: 1, display: 'flex', justifyContent: 'center' }}>
            <Typography variant="h3" color="primary" component="div" sx={{ width: '100%', textAlign: 'center' }}>
              <ReactFitty maxSize={50}>{codes.promoCode || ''}</ReactFitty>
            </Typography>
          </Box>
        )}
        {active === 'barcode' && codes.barcode && <FluidBarcode code={codes.barcode} />}
        {active === 'qrCode' && codes.qrCode && <FluidQrcode code={codes.qrCode} />}
      </Box>
    </Box>
  );
}
